const elements = '[name="checkout"], .cart__checkout-button, .button.button-checkout, button[name="checkout"], .cart__checkout';

window.turnstileSuccess = function(token) {
    onTurnstileSuccess();
};

function renderTurnstile() {
    if (window.turnstile) {
        turnstile.render("#turnstile-container", {
            sitekey: "0x4AAAAAAD6mX-kLmZVTgTLp",
            callback: function() {
                onTurnstileSuccess();
            },
            size: "flexible"
        });
    } else {
        setTimeout(renderTurnstile, 100);
    }
}

function renderTurnstileMorePayment() {
    if (jQuery("#turnstile-container-more-payment").length <= 0) {
        jQuery('.shopify-payment-button').prepend("<div style='margin-top: 15px;' id='turnstile-container-more-payment'></div>");
    }
    if (window.turnstile) {
        turnstile.render("#turnstile-container-more-payment", {
            sitekey: "0x4AAAAAAD6mX-kLmZVTgTLp",
            callback: function() {
                onTurnstileMorePaymentSuccess();
            },
            size: "flexible"
        });
    } else {
        setTimeout(renderTurnstileMorePayment, 100);
    }
}

function onTurnstileSuccess() {
    console.log("onTurnstileSuccess", true);
    jQuery(elements).attr("disabled", false);
    enableSezzleButton();
}

function onTurnstileMorePaymentSuccess() {
    jQuery(".shopify-payment-button").css("display", "block");
}


function disableSezzleButton() {
    const timer = setInterval(function () {
        const $button = jQuery(".sezzle-checkout-button");

        if (!$button.length) return;

        $button.css({
            "opacity": "0.7",
            "pointer-events": "none",
            "cursor": "not-allowed"
        });

        clearInterval(timer);
    }, 200);
}

function enableSezzleButton() {
    jQuery(".sezzle-checkout-button").css({
        "opacity": "",
        "pointer-events": "",
        "cursor": ""
    });
}


jQuery(document).ready(function() {

    if (jQuery('.shopify-payment-button').length > 0) {
        jQuery('.shopify-payment-button').css("display", "none");
        jQuery('.shopify-payment-button').prepend("<div style='margin-top: 15px;' id='turnstile-container-more-payment'></div>");
    }
    setTimeout(function(){
        if (jQuery('.shopify-payment-button').length > 0) {
            renderTurnstileMorePayment();
        }
    }, 1000);
    /*setTimeout(function(){
        console.log("[data-cart-submit]");
        jQuery('[data-cart-submit]').attr('disabled', true);
    }, 2000);*/
});
disableSezzleButton();